class Formatters {
  /**
   * Format date to MM/DD/YYYY
   * @param {Date|string} date
   * @returns {string}
   */
  static formatDate(date) {
    if (!date) return ''
    const d = new Date(date)
    return `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear()}`
  }

  /**
   * Format number with specific decimals
   * @param {number} value
   * @param {number} decimals
   * @returns {string}
   */
  static formatNumber(value, decimals = 2) {
    if (isNaN(value)) return '-'
    return parseFloat(value).toFixed(decimals)
  }

  /**
   * Format currency with specific decimals
   * @param {number} value
   * @param {number} decimals
   * @returns {string}
   */
  static formatCurrency(value, decimals = 2) {
    const num = this.formatNumber(value, decimals)
    if(value === 0 || !value)
      return '-'
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(num).replace('$', '₱')
  }

    static formatCurrencyWithoutSymbol(value, decimals = 2) {
    const num = this.formatNumber(value, decimals)
    if(value === 0 || !value)
      return '-'
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(num).replace('$', '')
  }

  /**
   * Pad numbers with leading zeros
   * @param {number} num
   * @param {number} length
   * @returns {string}
   */
  static padNumber(num, length = 8) {
    return num.toString().padStart(length, '0')
  }
}

export default Formatters